export default __webpack_public_path__ + "static/media/oktaDark.35063967.svg";